import emrTypeHelper from '@/helper/emrType';
import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import { InputNumber } from 'antd';
import * as React from 'react';

export interface IEmrInputNumberProps extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'> {
  disabled?: boolean;
}

const EmrInputNumber: React.FC<IEmrInputNumberProps> = ({ disabled, field, labelProps = {}, name, ...props }) => {
  return (
    <EmrFormItem field={field} name={name} {...labelProps} initialValue={disabled ? undefined : field?.default}>
      <InputNumber
        disabled={disabled}
        className={'base-input-number w-full'}
        {...props}
        suffix={field?.unit}
        formatter={(s) => emrTypeHelper.toFix(field, s)}
        parser={(s) => emrTypeHelper.toFix(field, s)}
      />
    </EmrFormItem>
  );
};
export default EmrInputNumber;
